export const VIEW = 'VIEW';
export const MANAGE = 'MANAGE';
export const DELETE = 'DELETE';

export enum Permission {
  VIEW = 'VIEW',
  MANAGE = 'MANAGE',
  DELETE = 'DELETE',
}
